module.exports = __webpack_public_path__ + "static/media/adserver_decorative_section2.5b1cc511.png";